import { useEventCallback } from '@cian/react-utils';
import { useState, useCallback, useMemo, FC, PropsWithChildren } from 'react';
import { ChatContext, useApplicationContext } from '../../context';
import { requestAuthentication } from '../../services/requestAuthentication';
import { useOfferContext } from '../OfferContext';

export const ChatContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const ctx = useApplicationContext();
  const { id, user } = useOfferContext();

  const [offerWithChat, setOfferWithChat] = useState<number | null>(null);
  const [defaultMessage, setDefaultMessage] = useState('');

  const updateOfferWithChat = useCallback(() => {
    setOfferWithChat(id);
  }, [id]);

  const closeChat = useEventCallback(() => {
    setOfferWithChat(null);
  });

  const openChat = useCallback(
    (defaultMessage?: string) => {
      if (defaultMessage) {
        setDefaultMessage(defaultMessage);
      }

      if (!user.isAuthenticated) {
        requestAuthentication(ctx, { onSuccess: updateOfferWithChat });

        return;
      }

      updateOfferWithChat();
    },
    [ctx, updateOfferWithChat, user],
  );

  const context = useMemo(
    () => ({ offerWithChat, openChat, closeChat, defaultMessage }),
    [offerWithChat, openChat, closeChat, defaultMessage],
  );

  return <ChatContext.Provider value={context}>{children}</ChatContext.Provider>;
};
